import React, { useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import copy from 'copy-to-clipboard';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useCreatePaymentLinkMutation } from '../../../hooks/usePayments';
import { BillingPeriod } from '../../../api/paymentsApi';

type PaymentLinkButtonProps = {
  text: string,
  accountId: string,
  planDefinitionId: string,
}

export const PaymentLinkButton = ({
  text,
  accountId,
  planDefinitionId,
}: PaymentLinkButtonProps):JSX.Element => {
  const [textWasCopied, setTextWasCopied] = useState(false);

  const createPaymentLink = useCreatePaymentLinkMutation();

  const handleClick = async () => {
    const data = await createPaymentLink.mutateAsync({ accountId, planDefinitionId, billingPeriod: BillingPeriod.Monthly  });
    copy(data.url);
    setTextWasCopied(true);
    setTimeout(() => {
      setTextWasCopied(false);
    }, 5000);
  };
  
  return (
    <LoadingButton
      loading={ createPaymentLink.isLoading }
      disabled={ createPaymentLink.isLoading }
      variant="text"
      onClick={ handleClick }
      startIcon={ textWasCopied ? <CheckCircleIcon style={ { fill: 'green' } } /> : <MonetizationOnIcon /> }
    >
      { textWasCopied ? 'Copied!' : text }
    </LoadingButton>
  );
};
